import utils from '@eitje/utils'
import {Environment, Invoice} from '@eitje/api'

export const useEnvironmentFilter = ({fixedFilter}) => {
	let items = Environment.useAll()
	const invoices = Invoice.useWhereNot({status: ['paid', 'disregard']})

	if (fixedFilter === 'withCoordinates') {
		items = items.whereNot({lat: null, lng: null})
	}

	if (fixedFilter === 'withUnpaidInvoices') {
		items = items.filter(({id}) => invoices.some(({environment_ids}) => environment_ids.includes(id)))
	}

	const filterFn = (item, filterValues) => {
		const {id, environment_id, environment_ids} = item
		const ids = utils.alwaysArray(environment_id || environment_ids || id)

		return ids.some(id => filterValues.includes(id))
	}

	return {
		items,
		filterFn,
		labelField: 'naam',
	}
}
